import { useUserStore } from '@/store/user'
import { useExamFilterStore } from '@/store/examFilter';
import { watch } from 'vue'

import ClinicChangeOffcanvas from './clinic/ClinicChangeOffcanvas.vue'
import ExamFilter from './exam/ExamFilter.vue'
import PatientListSearchedOffcanvas from './patient/PatientListSearchedOffcanvas.vue'
import MenuProfile from './menu/MenuProfile.vue'
import MenuStorageBar from './menu/MenuStorageBar.vue'

export default {
  name: 'HomeHeader',
  components: {
    ClinicChangeOffcanvas,
    ExamFilter,
    PatientListSearchedOffcanvas,
    MenuProfile,
    MenuStorageBar
  },
  data: () => ({
    session: {
      collaborator: {},
      currentClinic: {}
    },
    isPaidService: false,
    searchValue: '',
    headerPatientList: {},
    isExamFilter: false,
    locale: null,
    isExamRoute: false,
    showLatestResults: false,
    examFilter: null,
    // hasFilterItems: false,
    patientFullName: '',
    debouncedSearch: null,
    examFilterStore: useExamFilterStore(),
    // currentFilter: {},
    isSmallScreen: false,
    isLoadingPatients: false,
    isSpecialist: false
  }),
  watch: {
    $route(to, from) {
      if (to.name == 'exam-list')
        this.isExamRoute = true
      else
        this.isExamRoute = false
    },
    // hasFilterItems(newValue) {
    //   if (newValue) {
    //     document.body.classList.add('has-filter');
    //   } else {
    //     document.body.classList.remove('has-filter');
    //   }
    // },
    // 'examFilterStore.filter': {
    //   handler(newFilterValue) {
    //     if (this.isSmallScreen) {
    //       return
    //     }
    //
    //     const newInnerFilter = newFilterValue.filter;
    //
    //     const hasDateFilters = newInnerFilter.startDate || newInnerFilter.endDate;
    //     const hasPropertiesFilters = newInnerFilter.properties && Object.keys(newInnerFilter.properties).some(key =>
    //       (key !== 'startDate' && key !== 'endDate' && typeof newInnerFilter.properties[key] === 'boolean' && newInnerFilter.properties[key] === true)
    //     )
    //
    //     this.hasFilterItems = !!(
    //       newInnerFilter.patientID ||
    //       hasDateFilters ||
    //       hasPropertiesFilters
    //     );
    //   },
    //   deep: true,
    // },
    'examFilterStore.filter.shouldCloseFilter': {
      handler(newValue) {
        if (this.isSmallScreen) {
          return
        }

        if (newValue === true) {
          this.closeExamFilterBox()
          this.examFilterStore.refreshFilter({ shouldCloseFilter: false })
        }
      },
      immediate: false,
      deep: false
    }
  },
  computed: {
    helpcenterUrl() {
      if (this.locale == 'pt-br')
        return 'https://phelcom.com/pt-br/helpcenter/'

      return 'https://phelcom.com/helpcenter/'
    },
    currentFilter() {
      return this.examFilterStore.filter.filter;
    },
    hasFilterItems() {
      const newInnerFilter = this.examFilterStore.filter.filter;
      const hasDateFilters = newInnerFilter.startDate || newInnerFilter.endDate;
      const hasPropertiesFilters = newInnerFilter.properties && Object.keys(newInnerFilter.properties).some(key =>
        (key !== 'startDate' && key !== 'endDate' && typeof newInnerFilter.properties[key] === 'boolean' && newInnerFilter.properties[key] === true)
      );

      if (newInnerFilter.patientID || hasDateFilters || hasPropertiesFilters) {
        document.body.classList.add('has-filter');
      } else {
        document.body.classList.remove('has-filter');
      }

      return !!(
        newInnerFilter.patientID ||
        hasDateFilters ||
        hasPropertiesFilters
      );
    },
  },
  mounted() {
    const userStore = useUserStore()

    this.isExamRoute = this.$router.currentRoute._value.name == 'exam-list'
    this.session = userStore.sessionInfo
    this.locale = this.session.currentClinic.locale.toLowerCase()
    this.isPaidService = this.$utils.getIsPaidService()
    this.isSpecialist = this.session.isSpecialist

    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.debouncedSearch = _.debounce(this.fetchPatients, 300);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if ((this.isExpanded || this.showLatestResults) && this.$refs.searchBox && !this.$refs.searchBox.contains(event.target)) {
        this.isExpanded = false;
        this.showLatestResults = false
        this.searchValue = ''
        this.headerPatientList = {}
      }
    },
    handleResize() {
      this.isSmallScreen = window.innerWidth < 992;
    },
    doSearch(event) {
      if (event && (event.key === 'ArrowLeft' || event.key === 'ArrowRight'))
        return

      this.debouncedSearch(this.searchValue);
    },
    async fetchPatients(partialName) {
      this.showLatestResults = false

      if (!partialName || partialName.length < 3) {
        this.headerPatientList = {};
        return;
      }

      this.loading = true;
      NProgress.start();
      try {
        const params = { partialName };
        const response = await this.$patientService.searchPatient(params);

        this.headerPatientList = response.result || {};
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
        // this.alert = this.$message.alert(this, 'request_error', 'danger');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    toPatientDetails(item) {
      this.searchValue = ''
      this.headerPatientList = {}

      //this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})

      this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'exams'}})
    },
    toExamDetails(event, item) {
      event.stopPropagation()
      let data = null
      this.searchValue = ''
      this.headerPatientList = {}
      //this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})

      this.$router.push({ name: 'exam-show', params: { examID: item.id }, query: { tab: 'images', data: data } })
    },
    toggleExamFilter() {
      this.isExamFilter = !this.isExamFilter

      if (this.isExamFilter)
        this.clearSearchValue()
    },
    formatDate(date) {
      return moment(date).format(this.$i18n.t('dateTimeFormat'))
    },
    async openChangeOffcanvas() {
      const ok = await this.$refs.clinicChangeOffcanvas.show({})
      if (ok) {}
    },
    updateExamFilter(payload) {
      const examFilterStore = useExamFilterStore();

      const mergedPayload = {
        newRequest: payload.newRequest !== undefined ? payload.newRequest : examFilterStore.filter.newRequest,
        examCurrentPage: payload.examCurrentPage !== undefined ? payload.examCurrentPage : examFilterStore.filter.examCurrentPage,

        filter: {
          ...examFilterStore.filter.filter,
          ...(payload.filter || {})
        }
      };

      examFilterStore.refreshFilter(mergedPayload);

      this.showLatestResults = false;
      this.searchValue = null;
      this.headerPatientList = {};

      // if (!this.isExamRoute) {
        sessionStorage.setItem('examFilters', JSON.stringify(examFilterStore.filter))
        this.$router.push('/exam/')
      // }
    },
    doFilterExamListByPatientID(item) {
      this.patientFullName = item.fullName;

      this.updateExamFilter({
        filter: { patientID: item.id },
        newRequest: true
      });
    },
    doFilterExamListLastSevenDays() {
      const startDate = moment().subtract(7, 'days').toDate();
      const endDate = moment().toDate();

      this.updateExamFilter({
        filter: {
          startDate: this.$utils.formatDate(this, startDate),
          endDate: this.$utils.formatDate(this, endDate),
        },
        newRequest: true
      });
    },

    clearFilteredList(filterKey) {
      const examFilterStore = useExamFilterStore()
      const currentTopLevelFilter = examFilterStore.filter
      const currentInnerFilter = currentTopLevelFilter.filter

      if (filterKey === 'all') {
        this.hasFilterItems = false
        examFilterStore.reset()
        examFilterStore.refreshFilter({ newRequest: true })
        return
      }

      let filterUpdates = {}
      let updatedProperties = { ...(currentInnerFilter.properties || {}) }

      switch (filterKey) {
        case 'name':
          this.patientFullName = ''
          filterUpdates.patientID = null
          break
        case 'date':
          filterUpdates.startDate = null
          filterUpdates.endDate = null
        break;
        case 'mcRas':
        case 'color':
        case 'redfree':
        case 'infrared':
        case 'segAnterior':
        case 'panoramic':
        case 'stereo':
        case 'eyermaps':
          updatedProperties[filterKey] = false
          filterUpdates.properties = updatedProperties
        break
        default:
         console.warn(`Unknown filter item: ${filterKey}`)
         return
      }

      this.updateExamFilter({ filter: filterUpdates, newRequest: true })
    },
    clearSearchValue() {
      this.searchValue = ''
      // this.showLatestResults = true
      this.headerPatientList = {}
    },
    async showAllSearchedPatients() {
      if (this.searchValue.length < 3)
        return

      this.isLoadingPatients = true
      const partialPatientName = this.searchValue

      const ok = await this.$refs.patientListSearchedHeaderOffcanvas.show({
        patientName: partialPatientName,
      })
      if (ok) {
        this.doFilterExamListByPatientID(ok);
      }

      this.isLoadingPatients = false
    },
    handleInputClick() {
      if (Object.keys(this.headerPatientList).length > 0) {
        return
      }

      // this.showLatestResults = true;
    },
    closeExamFilterBox() {
      this.showDateFilter = false
      this.searchMode = 'patient'
      this.isExpanded = false
      this.isExamFilter = false
      this.clearSearchValue()
    },
  }
}
